import {Mapper} from '@s-ui/domain'

export default class FromModelInfoRawDataToModelInfoValueObjectMapper extends Mapper {
  constructor({
    fromBodyTypesListRawDataToBodyTypesListValueObjectMapper,
    fromVehiclesListRawDataToVehiclesListValueObjectMapper,
    fromRelatedVehiclesListRawDataToRelatedVehiclesListValueObjectMapper,
    fromImagesListRawDataToImagesListValueObjectMapper,
    valueObject
  }) {
    super()
    this._fromBodyTypesListRawDataToBodyTypesListValueObjectMapper =
      fromBodyTypesListRawDataToBodyTypesListValueObjectMapper
    this._fromVehiclesListRawDataToVehiclesListValueObjectMapper =
      fromVehiclesListRawDataToVehiclesListValueObjectMapper
    this._fromRelatedVehiclesListRawDataToRelatedVehiclesListValueObjectMapper =
      fromRelatedVehiclesListRawDataToRelatedVehiclesListValueObjectMapper
    this._fromImagesListRawDataToImagesListValueObjectMapper = fromImagesListRawDataToImagesListValueObjectMapper
    this._valueObject = valueObject
  }

  map = ({modelInfo, makeCode, modelCode, bodyTypeCode, doorsCode}) => {
    const {items: bodyTypes} = this._fromBodyTypesListRawDataToBodyTypesListValueObjectMapper
      .map({
        bodyTypes: modelInfo.modelBodyTypes || modelInfo.selectedModelBodyTypes?.bodyTypes,
        selectedBodyType: modelInfo.selectedModelBodyTypes?.selectedBodyType,
        selectedDoors: doorsCode
      })
      .toJSON()

    const {items: vehicles} = this._fromVehiclesListRawDataToVehiclesListValueObjectMapper
      .map({vehicles: modelInfo.vehicles})
      .toJSON()

    const {items: relatedVehicles} = this._fromRelatedVehiclesListRawDataToRelatedVehiclesListValueObjectMapper
      .map({relatedVehicles: modelInfo.competitors})
      .toJSON()

    const {items: images} = this._fromImagesListRawDataToImagesListValueObjectMapper
      .map({images: modelInfo.images})
      .toJSON()

    const {year, makeId} = modelInfo

    modelInfo = {
      bodyTypes,
      vehicles,
      relatedVehicles,
      images,
      year,
      makeId,
      make: makeCode,
      model: modelCode,
      bodyType: bodyTypeCode,
      doors: doorsCode
    }

    return this._valueObject({modelInfo})
  }
}
